// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__IfCVm","main-image":"Header_main-image__2-d7s"};